<template>
  <b-modal v-model="modalShow"  id="Vertragbeenden" :title="$t('VertragBeenden')">
    <b-container fluid v-if="typeof betrieb != 'undefined' ">
 <b-alert show>{{$t('VertragBeendenInfo')}}</b-alert>
        
      {{betrieb.agis}}
      <br>
      {{verwerter.name}}
      <br>
      <b-form inline class="mt-3">
        <b-form-group :label="$t('Bis')">
          <vue-monthly-picker
            v-model="kuendenDatum"
            :min="monthPickerMinDate"
            
            dateFormat="MM.YYYY"
            placeHolder="2018-12"
            inputClass="input"
            :monthLabels="monate"
          ></vue-monthly-picker>
        </b-form-group>

      </b-form>
    </b-container>
    <div slot="modal-footer"  >
       <b-button   variant="secondary" @click.stop="close">{{ $t('Abbrechen') }}</b-button> &nbsp;
       <b-button  variant="primary" @click.stop="save">{{ $t('Speichern') }}</b-button>&nbsp;
       <!-- <b-button   variant="secondary" @click.stop="close">{{ $t('close') }}</b-button> &nbsp;-->
    </div>
  </b-modal>
</template>

<script>
/*

this.$refs["bkdialog"].openDialog(btrid,perid)



import { bus, i18n } from "../main"

*/
import moment from "moment";
import { apiURL, axios } from "../../main";
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  name: "BeziehungenKuenden",
  components: { VueMonthlyPicker },
  data() {
    return {
      kuendenDatum: 0,
      btrid: 0,
      perid: 0,
      tierartid: 0,
      ready: 0,
      letzeEinlieferung: { hasEinlieferung: 0, vmmDate: null },
      modalShow: false,
      monate: [
        this.$t("mmm_01"),
        this.$t("mmm_02"),
        this.$t("mmm_03"),
        this.$t("mmm_04"),
        this.$t("mmm_05"),
        this.$t("mmm_06"),
        this.$t("mmm_07"),
        this.$t("mmm_08"),
        this.$t("mmm_09"),
        this.$t("mmm_10"),
        this.$t("mmm_11"),
        this.$t("mmm_12")
      ]
    };
  },
  computed: {
    betrieb() {
      let self = this;
      return this.$store.state.beziehungenStore.beziehungen.find(function(
        betrieb
      ) {
        return betrieb.bid == self.btrid;
      });
    },
    verwerter() {
      let self = this;
      return this.betrieb.milchkaeufer.find(function(verwerter) {
        return (
          verwerter.verwerterperid == self.perid &&
          verwerter.tierartid == self.tierartid
        );
      });
    },
    monthPickerMinDate() {
      // der monthpicker mag Moment oder null :: https://www.npmjs.com/package/vue-monthly-picker
      return this.letzeEinlieferung.hasEinlieferung == true
        ? this.letzeEinlieferung.vmmDate
        : null;
    }
  },
  methods: {
    async open(btrid, perid, tierartid) {
      this.btrid = btrid;
      this.perid = perid;
      this.tierartid = tierartid;
      try {
        let jqxhr = await axios.get(
          apiURL + "beziehungen.cfc?method=getLastEinlieferung",
          {
            params: {
              btrid: this.btrid,
              perid: this.perid,
              tierartid: this.tierartid
            }
          }
        );
        this.letzeEinlieferung = jqxhr.data;
        this.letzeEinlieferung.vmmDate =
          this.letzeEinlieferung.hasEinlieferung == true
            ? moment.utc(this.letzeEinlieferung.vmmDate)
            : null;
        this.kuendenDatum =
          this.letzeEinlieferung.hasEinlieferung == true
          ? moment(this.letzeEinlieferung.vmmDate).add(1, "M")
          : moment();


        this.modalShow = true;
      } catch (e) {
        this.modalShow = false;
      }
    },
    close() {
      this.modalShow = false;
    },
    async save() {
        try {
        await axios.get(
          apiURL + "beziehungen.cfc?method=setVertragBeenden",
          {
            params: {
              btrid: this.btrid,
              perid: this.perid,
              tierartid: this.tierartid,
              bis: moment(this.kuendenDatum).endOf('month').format('YYYY-MM-DD')  // .toISOString() cf2016 kann noch keine Iso Zoulu Zeit : "2013-07-17T23:00:00.000Z"
            }
          }
        )
      } catch (e) {
        //console.log(e)
      }
      
      this.$store.dispatch("loadBeziehungen")
      this.modalShow = false;
    }
  },
  created() {},
  mounted() {},
  updated() {}
};
</script>
